/** A string with content, else `null`: empty / whitespace-only / nullish all read as "no value". Raw Salesforce picklists carry "" as often as NULL, so raw-render sites normalize through this before falling back. */
export function nonBlank(v: string | null | undefined): string | null {
  return v == null || v.trim() === '' ? null : v;
}

/** "A · B" over the non-blank parts; `null` when none. */
export function joinNonBlank(parts: ReadonlyArray<string | null | undefined>, sep = ' · '): string | null {
  const kept = parts.map(nonBlank).filter((p): p is string => p !== null);
  return kept.length > 0 ? kept.join(sep) : null;
}
